<template>
  <div class="tabsWrapper">
    <ToolbarContainer>
      <template v-slot:toolbar>
        <TabBar
          class="tabBar"
        >
          <template v-slot:tabs>
            <Tabs
              :activeTab="activeTab"
              :tabs="$options.tabList"
            />
          </template>
        </TabBar>
      </template>
      <template v-slot:body>
        <div
          class="toolbarBody"
        >
          <UpgradeNudge
            v-if="showBadge"
            :data-test-id="$testId('upgradeNudge')"
          />
          <PasswordManagerOverview
            v-if="showOverview"
            @showGroupModal="handleShowGroupModal"
          />
          <PasswordManagerSharedFolders v-if="showSharedFolders" />
          <PasswordManagerUsers
            v-if="showUsers"
            @showGroupModal="handleShowGroupModal"
          />
          <PasswordManagerSettings v-if="showSettings" />
        </div>
      </template>
    </ToolbarContainer>

    <PasswordManagerUserGroupModal
      :applicationId="applicationId"
      :showModal="showUserGroupModal"
      @close="handleCloseUserGroupModal"
    />
  </div>
</template>

<script>
import {
  TabBar,
  Tabs,
  ToolbarContainer,
  Types,
} from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';
import { passwordManagerRoutes, passwordManagerTabs } from 'client/PasswordManager/PasswordManagerConstants';
import PasswordManagerOverview from 'client/PasswordManager/components/PasswordManagerOverview.vue';
import PasswordManagerSettings from 'client/PasswordManager/Settings/PasswordManagerSettings.vue';
import PasswordManagerSharedFolders from 'client/PasswordManager/components/PasswordManagerSharedFolders.vue';
import PasswordManagerUserGroupModal from 'client/PasswordManager/components/PasswordManagerUserGroupModal.vue';
import PasswordManagerUsers from 'client/PasswordManager/components/PasswordManagerUsers.vue';
import UpgradeNudge from 'client/components/Nudge/UpgradeNudge.vue';

const PasswordManagerModule = 'PasswordManagerModule';

const { TabItem } = Types;

const tabList = [
  TabItem({
    label: 'Overview',
    key: passwordManagerTabs.overview,
    to: passwordManagerRoutes.overview,
  }),
  TabItem({
    key: passwordManagerTabs.users,
    label: 'Users',
    to: passwordManagerRoutes.users,
  }),
  TabItem({
    label: 'Shared Folders',
    key: passwordManagerTabs.sharedFolders,
    to: passwordManagerRoutes.sharedFolders,
  }),
  TabItem({
    label: 'Settings',
    key: passwordManagerTabs.settings,
    to: passwordManagerRoutes.settings,
  }),
];

export default {
  name: 'PasswordManagerTabs',

  components: {
    PasswordManagerOverview,
    PasswordManagerSettings,
    PasswordManagerSharedFolders,
    PasswordManagerUserGroupModal,
    PasswordManagerUsers,
    TabBar,
    Tabs,
    ToolbarContainer,
    UpgradeNudge,
  },

  props: {
    activeTab: {
      type: String,
      default: passwordManagerTabs.overview,
    },
  },

  data() {
    return {
      showUserGroupModal: false,
    };
  },

  computed: {
    ...mapGetters(PasswordManagerModule, {
      applicationId: 'getPasswordManagerApplicationId',
    }),

    showBadge() {
      return this.$hasFeatureFlag(this.$featureFlags.passwordManagerTrial)
        && !(this.$route.name === 'passwordManagerOverview' || this.$route.name === 'passwordManager');
    },

    showOverview() {
      return this.activeTab === passwordManagerTabs.overview;
    },

    showSettings() {
      return this.activeTab === passwordManagerTabs.settings;
    },

    showSharedFolders() {
      return this.activeTab === passwordManagerTabs.sharedFolders;
    },

    showUsers() {
      return this.activeTab === passwordManagerTabs.users;
    },
  },

  tabList,

  methods: {
    handleCloseUserGroupModal() {
      this.showUserGroupModal = false;
    },

    handleShowGroupModal() {
      this.showUserGroupModal = true;
    },
  },
};
</script>

<style scoped>
  .tabBar {
    margin-top: var(--jc-spacer);
    padding: 0 var(--jc-spacer);
  }

  .tabsWrapper {
    height: 100%;
  }

  .toolbarBody {
    max-height: calc(100vh - 50px - 3.5rem);
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
